const o="authToken",t="token";export{o as COOKIE_AUTH_TOKEN,t as COOKIE_REQUEST_ID};
